// Custom token cache for Capacitor using localStorage
// Based on Clerk's Expo implementation for native environments

export const clerkTokenCache = {
  async getToken(key) {
    try {
      const token = localStorage.getItem(key);
      return token;
    } catch (error) {
      console.error('Error getting token:', error);
      return null;
    }
  },

  async saveToken(key, token) {
    try {
      localStorage.setItem(key, token);
    } catch (error) {
      console.error('Error saving token:', error);
    }
  },

  async clearToken(key) {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error('Error clearing token:', error);
    }
  },
};
